/* ==========================================================================
   POPPOSHH — comportamientos compartidos
   Vanilla, sin dependencias. Reemplaza la logica DCLogic del preview.
   ========================================================================== */
(function () {
  'use strict';

  /* El script se referencia desde cada seccion, asi que el navegador lo
     ejecuta varias veces en la misma pagina. Sin esta guarda se duplican
     listeners y el marquee se clona de mas. */
  if (window.__pshhBooted) return;
  window.__pshhBooted = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Marca que el JS corrio. El CSS solo esconde los [data-pshh-reveal]
     cuando existe .pshh-js, asi que sin JS el contenido se ve igual. */
  document.documentElement.classList.add('pshh-js');

  /* ------------------------------------------------------------------
     Reveal al entrar en viewport
     ------------------------------------------------------------------ */
  function initReveal() {
    var els = document.querySelectorAll('[data-pshh-reveal]');
    if (!els.length) return;

    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          var d = e.target.getAttribute('data-pshh-delay');
          if (d) e.target.style.setProperty('--pshh-delay', d + 'ms');
          e.target.classList.add('is-in');
          io.unobserve(e.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.06 }
    );
    els.forEach(function (el) { io.observe(el); });
  }

  /* ------------------------------------------------------------------
     Bloqueo de scroll del body (drawer / buscador)
     ------------------------------------------------------------------ */
  var lockCount = 0;
  var scrollY = 0;

  function lockBody(on) {
    if (on) {
      if (lockCount === 0) {
        scrollY = window.scrollY;
        document.body.style.position = 'fixed';
        document.body.style.top = -scrollY + 'px';
        document.body.style.width = '100%';
      }
      lockCount++;
    } else {
      lockCount = Math.max(0, lockCount - 1);
      if (lockCount === 0) {
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.width = '';
        window.scrollTo(0, scrollY);
      }
    }
  }

  /* ------------------------------------------------------------------
     Overlay generico: drawer del menu y buscador
     ------------------------------------------------------------------ */
  function initOverlays() {
    /* Guardamos ids, no nodos: el bag drawer se re-renderiza con la Section
       Rendering API y el nodo viejo queda desprendido. Si guardaramos la
       referencia, despues de agregar un producto la X dejaria de cerrar. */
    var open = null;

    function panelAbierto() {
      return open ? document.getElementById(open.id) : null;
    }

    function show(id, extraId) {
      var panel = document.getElementById(id);
      if (!panel) return;
      if (open) hide();
      open = { id: id, extras: extraId ? [extraId] : [] };
      panel.hidden = false;
      open.extras.forEach(function (x) {
        var n = document.getElementById(x);
        if (n) n.hidden = false;
      });
      lockBody(true);
      var focusable = panel.querySelector('input, button, a[href]');
      if (focusable) focusable.focus({ preventScroll: true });
    }

    function hide() {
      if (!open) return;
      var panel = panelAbierto();
      if (panel) panel.hidden = true;
      open.extras.forEach(function (x) {
        var n = document.getElementById(x);
        if (n) n.hidden = true;
      });
      lockBody(false);
      open = null;
    }

    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-pshh-open]');
      if (opener) {
        e.preventDefault();
        show(opener.getAttribute('data-pshh-open'), opener.getAttribute('data-pshh-open-with'));
        return;
      }
      if (e.target.closest('[data-pshh-close]')) {
        e.preventDefault();
        hide();
        return;
      }
      /* Click fuera. Dos casos:
         - drawer con overlay aparte: el click cae fuera del panel
         - modal que es su propio backdrop: el click cae en el panel mismo,
           no en su contenido, asi que comparamos con e.target directo */
      var panel = panelAbierto();
      if (!panel) return;
      /* los +/- del bag reemplazan el nodo: el target ya no esta en el DOM
         cuando llega este handler, no es un click "fuera" */
      if (!e.target.isConnected) return;
      if (!panel.contains(e.target) || e.target === panel) hide();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && open) hide();
    });

    /* al navegar dentro del drawer, cerrarlo */
    document.addEventListener('click', function (e) {
      var panel = panelAbierto();
      if (panel && e.target.closest('a[href]') && panel.contains(e.target)) hide();
    });

    /* para que el drawer pueda abrirse desde otro modulo (add to cart) */
    abrirOverlay = show;
  }

  /* lo llena initOverlays; asi initBag no necesita duplicar la logica */
  var abrirOverlay = function () {};

  /* ------------------------------------------------------------------
     Predictive search de Shopify en el overlay
     ------------------------------------------------------------------ */
  function initSearch() {
    var input = document.querySelector('[data-pshh-search-input]');
    var out = document.querySelector('[data-pshh-search-results]');
    var none = document.querySelector('[data-pshh-search-none]');
    var hint = document.querySelector('[data-pshh-search-hint]');
    if (!input || !out) return;

    /* Los tres estados del aprobado son excluyentes: resultados, "no hubo
       nada" (solo con 2+ caracteres) y las populares (solo campo vacio). */
    function estado(cual) {
      out.hidden = cual !== 'hits';
      if (none) none.hidden = cual !== 'none';
      if (hint) hint.hidden = cual !== 'hint';
    }

    var timer = null;
    var ctrl = null;

    /* OJO: search/suggest.json devuelve el precio como string en unidades
       mayores ("27.85"), no en centavos como el resto de las APIs del carrito.
       Dividir entre 100 aqui daba $0.28. */
    function money(valor) {
      var n = typeof valor === 'string' ? parseFloat(valor) : Number(valor) / 100;
      if (!isFinite(n)) return '';
      var f = window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : 'USD';
      try {
        return new Intl.NumberFormat(undefined, { style: 'currency', currency: f }).format(n);
      } catch (err) {
        return '$' + n.toFixed(2);
      }
    }

    /* Mismo recorte que snippets/popposhh-name.liquid, para que el buscador no
       muestre un nombre distinto al de la tarjeta. Nota: search/suggest.json no
       devuelve metafields, asi que aqui no se puede aplicar el override
       custom.short_name. */
    function nombreCorto(titulo, marca) {
      var t = String(titulo || '');
      var m = String(marca || '').trim();
      if (m && t.trim().toUpperCase().indexOf(m.toUpperCase()) === 0) {
        t = t.trim().slice(m.length);
      }
      t = t.replace(/\s[\u2013\u2014]\s/g, '|')
           .replace(/[\u2013\u2014]/g, '|')
           .replace(/\s-\s/g, '|');
      var trozos = t.split('|');
      for (var i = 0; i < trozos.length; i++) {
        var limpio = trozos[i].trim().replace(/^[\u00ae\u2122]\s*/, '');
        if (limpio.length > 2) return limpio;
      }
      return String(titulo || '');
    }

    function esc(t) {
      return String(t == null ? '' : t)
        .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    }

    function render(items) {
      if (!items.length) {
        out.innerHTML = '';
        estado('none');
        return;
      }
      out.innerHTML = items
        .map(function (p) {
          var img = p.featured_image && p.featured_image.url ? p.featured_image.url : '';
          /* el aprobado muestra "MARCA · CATEGORIA" arriba del nombre */
          var meta = [p.vendor, p.type].filter(Boolean).join(' \u00b7 ');
          return (
            '<a class="pshh-search__hit" href="' + esc(p.url) + '">' +
            '<span class="pshh-search__hit-thumb">' +
            (img
              ? '<img src="' + esc(img) + '" alt="" loading="lazy">'
              : '<span class="pshh-search__hit-star">\u2726</span>') +
            '</span>' +
            '<span><span class="pshh-search__hit-brand">' + esc(meta) + '</span>' +
            '<span class="pshh-search__hit-name">' + esc(nombreCorto(p.title, p.vendor)) + '</span></span>' +
            '<span class="pshh-search__hit-price">' + money(p.price) + '</span>' +
            '</a>'
          );
        })
        .join('');
      estado('hits');
    }

    input.addEventListener('input', function () {
      var q = input.value.trim();
      clearTimeout(timer);
      if (ctrl) ctrl.abort();
      if (q.length < 2) {
        out.innerHTML = '';
        /* con 1 caracter el aprobado no muestra nada: ni resultados, ni el
           mensaje de vacio, ni las populares */
        estado(q.length === 0 ? 'hint' : 'nada');
        return;
      }
      timer = setTimeout(function () {
        ctrl = new AbortController();
        var url =
          window.Shopify && window.Shopify.routes && window.Shopify.routes.root
            ? window.Shopify.routes.root
            : '/';
        fetch(
          url + 'search/suggest.json?q=' + encodeURIComponent(q) +
            '&resources[type]=product&resources[limit]=8',
          { signal: ctrl.signal }
        )
          .then(function (r) { return r.json(); })
          .then(function (d) {
            render((d.resources && d.resources.results && d.resources.results.products) || []);
          })
          .catch(function () { /* abortado o red caida: dejamos lo que hay */ });
      }, 180);
    });
  }

  /* ------------------------------------------------------------------
     Contador del carrito
     ------------------------------------------------------------------ */
  function setCartCount(n) {
    document.querySelectorAll('[data-pshh-cart-count]').forEach(function (el) {
      el.textContent = n;
      el.hidden = !n;
      if (n && !reduce) {
        el.style.animation = 'none';
        void el.offsetWidth;
        el.style.animation = 'pshhPop .5s cubic-bezier(.2,1.4,.4,1)';
      }
    });
  }

  document.addEventListener('pshh:cart-updated', function (e) {
    if (e.detail && typeof e.detail.count === 'number') setCartCount(e.detail.count);
  });

  /* ------------------------------------------------------------------
     Marquee: duplica el grupo para que el loop no tenga corte
     ------------------------------------------------------------------ */
  function initMarquee() {
    document.querySelectorAll('.pshh-marquee__track').forEach(function (track) {
      if (track.dataset.pshhCloned) return;
      var group = track.querySelector('.pshh-marquee__group');
      if (!group) return;
      track.appendChild(group.cloneNode(true));
      track.dataset.pshhCloned = '1';
    });
  }

  /* ------------------------------------------------------------------
     Shop: facetas y orden. Ambos son formularios GET normales; el JS
     solo los auto-envia. Sin JS siguen funcionando con el boton Apply.
     ------------------------------------------------------------------ */
  function initShop() {
    var facets = document.querySelector('[data-pshh-facet-form]');
    if (facets) {
      /* Debajo de 920px el sidebar es un drawer. Ahi NO auto-enviamos:
         el usuario marca varios filtros y aplica con "Show results".
         Auto-enviar en el drawer recarga la pagina en cada tap y obliga
         a reabrirlo para el siguiente filtro. */
      var drawerMode = window.matchMedia('(max-width: 920px)');
      var t = null;

      function maybeSubmit(delay) {
        if (drawerMode.matches) return;
        clearTimeout(t);
        t = setTimeout(function () { submitFacets(facets); }, delay);
      }

      facets.addEventListener('change', function (e) {
        maybeSubmit(e.target.type === 'number' ? 600 : 0);
      });
      facets.addEventListener('input', function (e) {
        if (e.target.type === 'number') maybeSubmit(700);
      });
      facets.addEventListener('submit', function (e) {
        e.preventDefault();
        submitFacets(facets);
      });
    }

    var sort = document.querySelector('[data-pshh-sort] select');
    if (sort) {
      sort.addEventListener('change', function () {
        var u = new URL(window.location.href);
        u.searchParams.set('sort_by', sort.value);
        u.searchParams.delete('page');
        window.location.href = u.toString();
      });
    }
  }

  function submitFacets(form) {
    var params = new URLSearchParams();
    new FormData(form).forEach(function (v, k) {
      if (String(v).trim() !== '') params.append(k, v);
    });
    var base = window.location.pathname;
    var qs = params.toString();
    window.location.href = qs ? base + '?' + qs : base;
  }

  /* ------------------------------------------------------------------
     Agregar al carrito sin salir de la pagina
     ------------------------------------------------------------------ */
  function initAddToCart() {
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('[data-pshh-add]');
      if (!form) return;
      e.preventDefault();

      var btn = form.querySelector('button[type="submit"]');
      if (btn) btn.setAttribute('aria-busy', 'true');

      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          id: form.querySelector('[name="id"]').value,
          quantity: 1
        })
      })
        .then(function (r) {
          if (!r.ok) throw new Error('cart');
          return fetch(root + 'cart.js');
        })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          document.dispatchEvent(
            new CustomEvent('pshh:cart-updated', { detail: { count: cart.item_count } })
          );
          var card = form.closest('.pshh-card');
          var nombre = card ? (card.querySelector('.pshh-card__link') || {}).textContent : '';
          if (!nombre) nombre = (form.getAttribute('data-pshh-add-name') || '');
          showToast(nombre.trim(), cart.item_count);
          return refreshBag(false);
        })
        .catch(function () {
          /* si falla el fetch, mandamos el form como POST normal:
             el cliente termina en /cart en vez de quedarse sin feedback */
          form.submit();
        })
        .finally(function () {
          if (btn) btn.removeAttribute('aria-busy');
        });
    });
  }

  /* ------------------------------------------------------------------
     Galeria de la ficha: los thumbs cambian la imagen principal
     ------------------------------------------------------------------ */
  /* Galeria del producto: carrusel con scroll-snap.
     Antes se cambiaba el src del unico <img>: corte seco y parpadeo mientras
     cargaba la foto nueva. Ahora todas estan en la pista y se desliza. */
  function initGallery() {
    var track = document.querySelector('[data-pshh-track]');
    if (!track) return;

    var slides = track.querySelectorAll('[data-pshh-slide]');
    var thumbs = document.querySelectorAll('[data-pshh-thumb]');
    if (slides.length < 2) return;

    /* puntitos */
    var dots = document.createElement('div');
    dots.className = 'pshh-pdp__dots';
    dots.setAttribute('aria-hidden', 'true');
    Array.prototype.forEach.call(slides, function (_, i) {
      var d = document.createElement('span');
      d.className = 'pshh-pdp__dot' + (i === 0 ? ' is-active' : '');
      dots.appendChild(d);
    });
    track.parentElement.appendChild(dots);

    var settleTimer = null;

    function irA(i) {
      var slide = slides[i];
      if (!slide) return;
      /* El snap se queda desactivado hasta que la animacion termina. Si se
         reactiva antes, el navegador salta al anclaje de golpe y no se ve
         moverse nada. */
      track.classList.add('is-settling');
      track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
      clearTimeout(settleTimer);
      settleTimer = setTimeout(function () {
        track.classList.remove('is-settling');
      }, reduce ? 0 : 620);
    }

    /* el selector de variantes necesita poder saltar a la foto de la variante */
    window.Popposhh = window.Popposhh || {};
    window.Popposhh.irAFoto = irA;

    function marcar(i) {
      Array.prototype.forEach.call(thumbs, function (b, j) { b.classList.toggle('is-active', j === i); });
      Array.prototype.forEach.call(dots.children, function (d, j) { d.classList.toggle('is-active', j === i); });
    }

    Array.prototype.forEach.call(thumbs, function (btn) {
      btn.addEventListener('click', function () {
        irA(Number(btn.getAttribute('data-pshh-thumb')) || 0);
      });
    });

    /* sincronizar al deslizar con el dedo o con el teclado */
    var t = null;
    track.addEventListener('scroll', function () {
      clearTimeout(t);
      t = setTimeout(function () {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        marcar(Math.max(0, Math.min(i, slides.length - 1)));
      }, 90);
    }, { passive: true });

    track.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
      e.preventDefault();
      var i = Math.round(track.scrollLeft / track.clientWidth);
      irA(e.key === 'ArrowRight' ? Math.min(i + 1, slides.length - 1) : Math.max(i - 1, 0));
    });

    /* Arrastre con el raton. Con el dedo no hace falta: el navegador ya
       desplaza el contenedor y le pone inercia, y si le metieramos mano
       perderiamos las dos cosas. Por eso solo se engancha pointerType mouse. */
    var arrastrando = false;
    var xIni = 0;
    var scrollIni = 0;
    var recorrido = 0;
    /* muestras recientes del gesto, para medir el impulso al soltar */
    var muestras = [];

    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      arrastrando = true;
      recorrido = 0;
      xIni = e.clientX;
      muestras = [{ x: e.clientX, t: performance.now() }];
      scrollIni = track.scrollLeft;
      clearTimeout(settleTimer);
      track.classList.remove('is-settling');
      track.classList.add('is-dragging');
      try { track.setPointerCapture(e.pointerId); } catch (err) {}
    });

    track.addEventListener('pointermove', function (e) {
      if (!arrastrando) return;
      var d = e.clientX - xIni;
      if (Math.abs(d) > recorrido) recorrido = Math.abs(d);
      track.scrollLeft = scrollIni - d;

      muestras.push({ x: e.clientX, t: performance.now() });
      if (muestras.length > 6) muestras.shift();
    });

    /* px por milisegundo en los ultimos ~120ms. Devuelve 0 si no se puede
       medir (muestras con el mismo instante), y entonces manda la distancia. */
    function impulso() {
      if (muestras.length < 2) return 0;
      var fin = muestras[muestras.length - 1];
      var ini = muestras[0];
      for (var i = muestras.length - 2; i >= 0; i--) {
        if (fin.t - muestras[i].t > 120) break;
        ini = muestras[i];
      }
      var dt = fin.t - ini.t;
      return dt > 0 ? (fin.x - ini.x) / dt : 0;
    }

    function soltar(e) {
      if (!arrastrando) return;
      arrastrando = false;
      track.classList.remove('is-dragging');
      try { track.releasePointerCapture(e.pointerId); } catch (err) {}

      var W = track.clientWidth;
      var actual = track.scrollLeft / W;
      var v = impulso();
      var destino;

      /* un gesto rapido pasa de foto aunque no llegues a la mitad; si el
         impulso no llega al umbral (o no se pudo medir), manda la distancia */
      if (Math.abs(v) > 0.3) {
        destino = v < 0 ? Math.ceil(actual) : Math.floor(actual);
      } else {
        destino = Math.round(actual);
      }
      irA(Math.max(0, Math.min(destino, slides.length - 1)));
    }
    track.addEventListener('pointerup', soltar);
    track.addEventListener('pointercancel', soltar);

    /* un arrastre no debe contar como clic (si algun dia la foto lleva enlace) */
    track.addEventListener('click', function (e) {
      if (recorrido > 6) { e.preventDefault(); e.stopPropagation(); }
    }, true);

    /* sin la imagen fantasma que arrastra el navegador por defecto */
    track.addEventListener('dragstart', function (e) { e.preventDefault(); });
  }

  /* ------------------------------------------------------------------
     Fecha de nacimiento: tres selects -> un campo oculto YYYY-MM-DD
     ------------------------------------------------------------------ */
  function initDob() {
    document.querySelectorAll('[data-pshh-dob]').forEach(function (wrap) {
      var out = wrap.querySelector('[data-dob-out]');
      var parts = {
        year: wrap.querySelector('[data-dob="year"]'),
        month: wrap.querySelector('[data-dob="month"]'),
        day: wrap.querySelector('[data-dob="day"]')
      };
      if (!out || !parts.year || !parts.month || !parts.day) return;

      function sync() {
        var y = parts.year.value, m = parts.month.value, d = parts.day.value;
        out.value = y && m && d ? y + '-' + m + '-' + d : '';
      }
      Object.keys(parts).forEach(function (k) {
        parts[k].addEventListener('change', sync);
      });
    });
  }

  /* ------------------------------------------------------------------
     Loop unico de scroll: hero, marquee y nav.
     Portado del diseno aprobado — antes tenia el reveal por tiempo y el
     marquee con animacion CSS, y ninguno de los dos se comportaba igual.
     ------------------------------------------------------------------ */
  function initScrollLoop() {
    var heroCapas = Array.prototype.slice.call(document.querySelectorAll('[data-pshh-hero-img]'));
    var heroImg = heroCapas[0];
    function filtroHero(css) { heroCapas.forEach(function (el) { el.style.filter = css; }); }
    var heroDuo = document.querySelector('[data-pshh-hero-duo]');
    var heroWrap = document.querySelector('[data-pshh-hero-wrap]');
    var canvas = document.querySelector('[data-pshh-hero-canvas]');
    var track = document.querySelector('.pshh-marquee__track');
    var header = document.querySelector('[data-pshh-header]');
    var clubFill = document.querySelector('[data-pshh-club-fill]');
    var ambBase = document.querySelector('.pshh-amb__base');
    var orbs = [
      document.querySelector('.pshh-amb__orb--a'),
      document.querySelector('.pshh-amb__orb--b'),
      document.querySelector('.pshh-amb__orb--c')
    ];

    /* El fondo ambiental cambia de color a lo largo del scroll: arranca
       oscuro, se abre a tonos claros en el medio y vuelve a oscuro al final.
       Portado de updateAura del diseno aprobado. */
    var STOPS = [
      { p: 0.00, base: [11, 11, 18],    o: [[0, 48, 255], [58, 92, 255], [157, 180, 255]] },
      { p: 0.28, base: [244, 241, 236], o: [[85, 102, 255], [179, 214, 255], [255, 205, 181]] },
      { p: 0.52, base: [242, 235, 231], o: [[138, 107, 255], [255, 205, 181], [179, 214, 255]] },
      { p: 0.74, base: [249, 239, 233], o: [[255, 158, 125], [255, 205, 181], [127, 140, 255]] },
      { p: 1.00, base: [11, 11, 18],    o: [[0, 48, 255], [122, 92, 255], [255, 181, 154]] }
    ];
    function mix(a, b, t) {
      return 'rgb(' + Math.round(a[0] + (b[0] - a[0]) * t) + ',' +
                      Math.round(a[1] + (b[1] - a[1]) * t) + ',' +
                      Math.round(a[2] + (b[2] - a[2]) * t) + ')';
    }
    function updateAura(frac) {
      if (!ambBase) return;
      var i = 0;
      while (i < STOPS.length - 2 && frac > STOPS[i + 1].p) i++;
      var a = STOPS[i], b = STOPS[i + 1];
      var t = Math.max(0, Math.min(1, (frac - a.p) / (b.p - a.p)));
      ambBase.style.backgroundColor = mix(a.base, b.base, t);
      for (var k = 0; k < 3; k++) {
        if (orbs[k]) orbs[k].style.background = mix(a.o[k], b.o[k], t);
      }
    }

    if (!heroImg && !track && !header && !clubFill && !ambBase) return;

    var heroP = 0, marqOff = 0, vel = 0, lastY = window.scrollY || 0, last = 0, navKey = '';

    if (reduce) {
      if (heroImg) filtroHero('grayscale(0) saturate(1.35) contrast(1.02) brightness(1.04)');
      if (heroDuo) heroDuo.style.opacity = '.16';
    }

    /* --------------------------------------------------------------
       Lineas neon sobre la foto del hero. 16 curvas senoidales que se
       mueven con el tiempo, van de plata a azul segun el reveal, y se
       desvanecen hacia la derecha para no tapar a la modelo.
       Portado tal cual de drawHeroReveal del diseno aprobado.
       -------------------------------------------------------------- */
    var dpr = Math.min(window.devicePixelRatio || 1, 1.6);
    var t0 = performance.now();

    function sizeCanvas() {
      if (!canvas) return;
      var w = canvas.clientWidth, h = canvas.clientHeight;
      if (!w || !h) return;
      canvas.width = Math.round(w * dpr);
      canvas.height = Math.round(h * dpr);
    }
    if (canvas) {
      sizeCanvas();
      if (window.ResizeObserver) new ResizeObserver(sizeCanvas).observe(canvas);
      else window.addEventListener('resize', sizeCanvas);
    }

    function maskRight(ctx, w, h) {
      ctx.globalCompositeOperation = 'destination-out';
      var g = ctx.createLinearGradient(0, 0, w, 0);
      g.addColorStop(0, 'rgba(0,0,0,0)');
      g.addColorStop(0.44, 'rgba(0,0,0,0)');
      g.addColorStop(0.72, 'rgba(0,0,0,1)');
      g.addColorStop(1, 'rgba(0,0,0,1)');
      ctx.fillStyle = g;
      ctx.fillRect(0, 0, w, h);
      ctx.globalCompositeOperation = 'source-over';
    }

    function drawHero(tSec, p) {
      if (!canvas) return;
      var ctx = canvas.getContext('2d');
      if (!ctx) return;
      var w = canvas.clientWidth, h = canvas.clientHeight;
      if (!w || !h) return;

      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      ctx.clearRect(0, 0, w, h);

      var acc = [0, 48, 255], sil = [226, 230, 240];
      var e = p * p * (3 - 2 * p);
      var r = Math.round(sil[0] + (acc[0] - sil[0]) * e);
      var g2 = Math.round(sil[1] + (acc[1] - sil[1]) * e);
      var b = Math.round(sil[2] + (acc[2] - sil[2]) * e);

      var N = 16;
      ctx.globalCompositeOperation = 'lighter';
      ctx.lineCap = 'round';

      for (var i = 0; i < N; i++) {
        var pp = i / N;
        var baseY = h * -0.06 + pp * h * 1.05;
        var amp = 16 + 30 * (1 - pp);
        var speed = tSec * 0.45 + i * 0.17;
        ctx.beginPath();
        for (var x = 0; x <= w; x += 8) {
          var k = x / w;
          var y = baseY +
                  Math.sin(x * 0.0062 + speed) * amp +
                  Math.sin(x * 0.0017 - tSec * 0.32 + pp * 3) * 30 * (1 - k * 0.3);
          if (x === 0) ctx.moveTo(x, y); else ctx.lineTo(x, y);
        }
        var a = (0.12 + 0.26 * (1 - pp)) * (0.28 + 0.72 * p);
        ctx.strokeStyle = 'rgba(' + r + ',' + g2 + ',' + b + ',' + a.toFixed(3) + ')';
        ctx.lineWidth = 2.1;
        ctx.shadowColor = 'rgba(' + r + ',' + g2 + ',' + b + ',' + (0.5 + 0.4 * p).toFixed(3) + ')';
        ctx.shadowBlur = 6 + 4 * p;
        ctx.stroke();
      }
      ctx.shadowBlur = 0;
      ctx.globalCompositeOperation = 'source-over';
      maskRight(ctx, w, h);
    }

    function applyHero(p) {
      if (heroImg) {
        filtroHero(
          'grayscale(' + (1 - p).toFixed(3) + ') ' +
          'saturate(' + (0.85 + 0.5 * p).toFixed(3) + ') ' +
          'contrast(' + (1.08 - 0.06 * p).toFixed(3) + ') ' +
          'brightness(' + (0.92 + 0.12 * p).toFixed(3) + ')'
        );
      }
      if (heroDuo) heroDuo.style.opacity = (0.16 * p).toFixed(3);
    }

    /* El nav se queda oscuro siempre. Antes miraba que seccion tenia debajo
       (data-pshh-lite / data-pshh-dark) y cambiaba a barra clara; con el tema
       oscuro ese cambio se veia como un parpadeo al bajar. Los atributos se
       quedan en el markup como nota del tono de cada seccion, ya nadie los lee. */
    function applyNav(scrolled) {
      if (!header) return;
      var key = scrolled ? 's' : 't';
      if (key === navKey) return;
      navKey = key;
      header.classList.toggle('is-scrolled', scrolled);
      header.classList.add('is-dark');
    }

    function frame(now) {
      var dt = Math.min(0.05, (now - (last || now - 16)) / 1000);
      last = now;
      var sy = window.scrollY || 0;
      vel = vel * 0.82 + (sy - lastY);
      lastY = sy;

      var docH = document.documentElement.scrollHeight - window.innerHeight;
      var frac = docH > 0 ? Math.max(0, Math.min(1, sy / docH)) : 0;
      updateAura(frac);
      applyNav(sy > 60);

      /* parallax del hero */
      if (heroWrap && !reduce) {
        heroWrap.style.transform = 'translateY(' + (sy * 0.16).toFixed(1) + 'px)';
      }

      /* blanco y negro -> color, por scroll, con suavizado */
      if (heroImg && !reduce) {
        var tp = Math.max(0, Math.min(1, sy / (window.innerHeight * 0.7)));
        heroP += (tp - heroP) * 0.12;
        applyHero(heroP);
        drawHero((now - t0) / 1000, heroP);
      }

      /* marquee: la velocidad reacciona al scroll y agrega skew */
      if (track && !reduce) {
        var speed = 55 + Math.min(Math.abs(vel) * 6, 260);
        marqOff -= speed * dt;
        var half = (track.scrollWidth / 2) || 1200;
        if (marqOff <= -half) marqOff += half;
        var skew = Math.max(-6, Math.min(6, vel * 0.24));
        track.style.transform =
          'translate3d(' + marqOff.toFixed(2) + 'px,0,0) skewX(' + skew.toFixed(2) + 'deg)';
      }

      /* el titular del Club se rellena a medida que entra en pantalla */
      if (clubFill) {
        var cr = clubFill.parentElement.getBoundingClientRect();
        var vh = window.innerHeight || 1;
        var cp = Math.max(0, Math.min(1, (vh * 0.85 - cr.top) / (vh * 0.55)));
        clubFill.style.width = (cp * 100).toFixed(1) + '%';
      }

      window.requestAnimationFrame(frame);
    }
    window.requestAnimationFrame(frame);
  }

  /* ------------------------------------------------------------------
     Flechas del feed social
     ------------------------------------------------------------------ */
  /* ------------------------------------------------------------------
     Testimonials: rotan cada 5.6s y se pausan si la pestana no se ve
     ------------------------------------------------------------------ */
  function initTesti() {
    var root = document.querySelector('[data-pshh-testi]');
    if (!root) return;
    var items = [].slice.call(root.querySelectorAll('[data-pshh-testi-item]'));
    var dots = [].slice.call(root.querySelectorAll('[data-pshh-testi-dot]'));
    if (items.length < 2) return;

    var i = 0, timer = null;
    function show(n) {
      i = ((n % items.length) + items.length) % items.length;
      items.forEach(function (el, k) { el.classList.toggle('is-active', k === i); });
      dots.forEach(function (el, k) { el.classList.toggle('is-active', k === i); });
    }
    function restart() {
      if (timer) clearInterval(timer);
      if (reduce) return;
      timer = setInterval(function () {
        if (!document.hidden) show(i + 1);
      }, 5600);
    }
    dots.forEach(function (d, k) {
      d.addEventListener('click', function () { show(k); restart(); });
    });
    show(0);
    restart();
  }

  /* ------------------------------------------------------------------
     Cursor custom: el dot sigue al mouse con inercia y crece sobre lo
     clickeable. El efecto magnetico de los botones que traia el mockup se
     quito a proposito: hacia que el boton se corriera justo al ir a clickearlo.
     ------------------------------------------------------------------ */
  function initCursor() {
    var dot = document.querySelector('[data-pshh-cursor]');
    if (!dot) return;
    if (reduce || window.matchMedia('(pointer: coarse)').matches) return;

    var mx = window.innerWidth / 2, my = window.innerHeight / 2;
    var cx = mx, cy = my, scale = 1;
    dot.style.opacity = '1';
    document.documentElement.style.cursor = 'none';

    window.addEventListener('pointermove', function (e) {
      mx = e.clientX;
      my = e.clientY;
    }, { passive: true });

    /* crece sobre cualquier cosa clickeable, sin tener que marcarlas una por una */
    var SEL = 'a[href], button, input, select, textarea, summary, [role="button"]';
    document.addEventListener('pointerover', function (e) {
      if (e.target.closest && e.target.closest(SEL)) scale = 2.6;
    });
    document.addEventListener('pointerout', function (e) {
      if (e.target.closest && e.target.closest(SEL)) scale = 1;
    });

    (function tick() {
      cx += (mx - cx) * 0.2;
      cy += (my - cy) * 0.2;
      dot.style.transform =
        'translate(' + cx.toFixed(1) + 'px,' + cy.toFixed(1) + 'px) translate(-50%,-50%) scale(' + scale + ')';
      window.requestAnimationFrame(tick);
    })();
  }

  /* ------------------------------------------------------------------
     Bag drawer. El markup lo genera Liquid; despues de cada cambio se pide
     la seccion de nuevo con la Section Rendering API y se reemplaza. Asi no
     hay que duplicar la plantilla en JS.
     ------------------------------------------------------------------ */
  var BAG_SECTION = 'popposhh-cart-drawer';

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function refreshBag(abrir) {
    return fetch(root() + '?sections=' + BAG_SECTION)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data[BAG_SECTION];
        if (!html) return;
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var nuevo = tmp.querySelector('#pshh-bag');
        var viejo = document.querySelector('#pshh-bag');
        if (nuevo && viejo) {
          var estabaAbierto = !viejo.hidden;
          nuevo.hidden = !(estabaAbierto || abrir);
          viejo.replaceWith(nuevo);
          var ov = document.querySelector('#pshh-bag-overlay');
          if (ov) ov.hidden = nuevo.hidden;
        }
      });
  }

  function cambiarLinea(linea, cantidad) {
    return fetch(root() + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: Number(linea), quantity: Number(cantidad) })
    })
      .then(function (r) {
        return r.json().then(function (cuerpo) {
          /* Shopify contesta 422 cuando no puede dar esa cantidad (stock).
             Antes esto se tragaba en silencio: el cliente pulsaba + y no
             pasaba nada, sin ninguna explicacion. */
          if (!r.ok) {
            var e = new Error('cart-change');
            e.aviso = cuerpo && (cuerpo.description || cuerpo.message);
            throw e;
          }
          return cuerpo;
        });
      })
      .then(function (cart) {
        document.dispatchEvent(new CustomEvent('pshh:cart-updated', { detail: { count: cart.item_count } }));
        return refreshBag(false).then(refrescarPaginaCarrito);
      })
      .catch(function (err) {
        if (err && err.aviso) {
          mostrarMensaje(err.aviso);
          /* la cantidad no cambio: repintar para que la pantalla no mienta */
          return refreshBag(false).then(refrescarPaginaCarrito);
        }
        throw err;
      });
  }

  /* Si estamos en /cart, los mismos +/- tienen que actualizar la pagina, no
     solo el drawer. Se pide la seccion de nuevo y se reemplaza, igual. */
  var CART_SECTION = 'popposhh-cart';
  function refrescarPaginaCarrito() {
    var actual = document.querySelector('[data-pshh-cart-page]');
    if (!actual) return;
    return fetch(root() + '?sections=' + CART_SECTION)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data[CART_SECTION];
        if (!html) return;
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var nuevo = tmp.querySelector('[data-pshh-cart-page]');
        if (nuevo) actual.replaceWith(nuevo);
      });
  }

  function initBag() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-pshh-qty]');
      if (!btn) return;
      e.preventDefault();
      btn.disabled = true;
      cambiarLinea(btn.getAttribute('data-pshh-line-index'), btn.getAttribute('data-pshh-qty'))
        .catch(function () { window.location.href = root() + 'cart'; });
    });
  }

  var toastTimer = null;
  var TOAST_OK = 'Added to bag';

  /* El toast sirve para las dos cosas: confirmar y avisar. Con titulo propio
     se distingue "Added to bag" de un aviso de stock. */
  function pintarToast(titulo, texto, ms) {
    var t = document.querySelector('[data-pshh-toast]');
    if (!t) return;
    var h = t.querySelector('.pshh-toast__title');
    var slot = t.querySelector('[data-pshh-toast-text]');
    if (h) h.textContent = titulo;
    if (slot) slot.textContent = texto || '';
    t.classList.toggle('pshh-toast--aviso', titulo !== TOAST_OK);
    t.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.hidden = true; }, ms || 2800);
  }

  /* mismo texto del aprobado: "<producto> \u00b7 N items in your bag" */
  function showToast(nombre, total) {
    var n = Number(total) || 0;
    pintarToast(
      TOAST_OK,
      (nombre ? nombre + ' \u00b7 ' : '') + n + (n === 1 ? ' item in your bag' : ' items in your bag')
    );
  }

  function mostrarMensaje(texto) {
    pintarToast('Heads up', texto || 'We could not update your bag.', 4200);
  }

  /* ------------------------------------------------------------------
     Load more del shop. Pide la misma seccion con ?section_id=... y le pega
     las tarjetas nuevas a la parrilla. El scroll no se mueve y no hay recarga.
     Sin JS el boton sigue siendo un <a> normal a la pagina siguiente.
     ------------------------------------------------------------------ */
  function initLoadMore() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-pshh-more-url]');
      if (!btn) return;
      e.preventDefault();
      if (btn.getAttribute('aria-busy') === 'true') return;

      var grid = document.querySelector('[data-pshh-grid]');
      var caja = btn.closest('[data-pshh-more]');
      if (!grid || !caja) return;

      var url = btn.getAttribute('data-pshh-more-url');
      var sec = btn.getAttribute('data-pshh-section');
      var sep = url.indexOf('?') === -1 ? '?' : '&';

      btn.setAttribute('aria-busy', 'true');

      fetch(url + sep + 'section_id=' + encodeURIComponent(sec))
        .then(function (r) {
          if (!r.ok) throw new Error('more');
          return r.text();
        })
        .then(function (html) {
          var tmp = document.createElement('div');
          tmp.innerHTML = html;

          var nuevas = tmp.querySelectorAll('[data-pshh-grid] > .pshh-card');
          if (!nuevas.length) throw new Error('vacio');

          var primera = null;
          Array.prototype.forEach.call(nuevas, function (card, i) {
            card.classList.add('pshh-card--nueva');
            card.style.animationDelay = Math.min(i, 8) * 40 + 'ms';
            grid.appendChild(card);
            if (i === 0) primera = card;
          });

          /* el bloque nuevo trae su propio boton y su propio conteo; si no
             viene ninguno es que ya no quedan mas paginas */
          var sigCaja = tmp.querySelector('[data-pshh-more]');
          if (sigCaja) {
            caja.replaceWith(sigCaja);
          } else {
            caja.remove();
          }

          /* que el lector de pantalla sepa donde sigue la lista */
          if (primera) {
            var foco = primera.querySelector('a');
            if (foco) foco.setAttribute('data-pshh-just-loaded', '1');
          }
        })
        .catch(function () {
          /* si falla, que el enlace haga lo suyo: ir a la pagina siguiente */
          window.location.href = btn.getAttribute('href');
        })
        .finally(function () {
          btn.removeAttribute('aria-busy');
        });
    });
  }

  /* Correos: la direccion no va en el HTML (ver snippets/popposhh-mail-link).
     Aqui se descifra y se arma el mailto. */
  function initMail() {
    document.querySelectorAll('[data-pshh-mail]').forEach(function (a) {
      var dir;
      try { dir = window.atob(a.getAttribute('data-pshh-mail')); } catch (err) { return; }
      if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(dir)) return;
      var asunto = a.getAttribute('data-pshh-mail-subject');
      a.href = 'mailto:' + dir + (asunto ? '?subject=' + encodeURIComponent(asunto) : '');
      if (a.hasAttribute('data-pshh-mail-text')) a.textContent = dir;
    });
  }

  /* ------------------------------------------------------------------
     Selector de variantes de la ficha.
     Solo corre si el producto tiene opciones reales; con variante unica el
     markup no existe y esto sale enseguida.
     ------------------------------------------------------------------ */
  function initVariants() {
    var caja = document.querySelector('[data-pshh-opts]');
    var datos = document.querySelector('[data-pshh-variants]');
    if (!caja || !datos) return;

    var variantes;
    try { variantes = JSON.parse(datos.textContent); } catch (e) { return; }
    if (!variantes || !variantes.length) return;

    var radios = caja.querySelectorAll('[data-pshh-opt-pos]');
    var campoId = document.querySelector('[data-pshh-variant-id]');
    var boton = document.querySelector('[data-pshh-add-btn]');
    var precio = document.querySelector('[data-pshh-price]');
    var antes = document.querySelector('[data-pshh-was]');

    function seleccion() {
      var sel = [];
      caja.querySelectorAll('[data-pshh-opt-pos]:checked').forEach(function (r) {
        sel[Number(r.getAttribute('data-pshh-opt-pos')) - 1] = r.value;
      });
      return sel;
    }

    function buscar(sel) {
      for (var i = 0; i < variantes.length; i++) {
        var v = variantes[i], igual = true;
        for (var j = 0; j < sel.length; j++) {
          if (sel[j] !== undefined && v.opts[j] !== sel[j]) { igual = false; break; }
        }
        if (igual) return v;
      }
      return null;
    }

    function dinero(centavos) {
      var n = Number(centavos) / 100;
      try {
        var f = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
        return new Intl.NumberFormat(undefined, { style: 'currency', currency: f }).format(n);
      } catch (e) { return '$' + n.toFixed(2); }
    }

    /* Marca las combinaciones que no se pueden comprar en vez de esconderlas:
       el cliente ve que ese tamano existe aunque no este. */
    function marcarAgotadas() {
      var sel = seleccion();
      radios.forEach(function (r) {
        var pos = Number(r.getAttribute('data-pshh-opt-pos')) - 1;
        var prueba = sel.slice();
        prueba[pos] = r.value;
        var v = buscar(prueba);
        var lbl = caja.querySelector('label[for="' + r.id + '"]');
        if (lbl) lbl.classList.toggle('is-out', !v || !v.disp);
      });
    }

    function aplicar() {
      var v = buscar(seleccion());
      marcarAgotadas();
      if (!v) return;

      if (campoId) campoId.value = v.id;
      if (precio) precio.textContent = dinero(v.precio);
      if (antes) {
        var hay = v.antes && Number(v.antes) > Number(v.precio);
        antes.hidden = !hay;
        if (hay) antes.textContent = dinero(v.antes);
      }
      if (boton) {
        boton.disabled = !v.disp;
        var txt = boton.firstChild;
        var etq = v.disp ? boton.getAttribute('data-pshh-label-add') : boton.getAttribute('data-pshh-label-out');
        if (txt && txt.nodeType === 3) txt.textContent = etq + ' ';
      }
      if (v.img && window.Popposhh && window.Popposhh.irAFoto) {
        window.Popposhh.irAFoto(v.img - 1);
      }
      /* la URL lleva la variante, para que compartirla abra la correcta */
      if (window.history && history.replaceState) {
        var u = new URL(window.location.href);
        u.searchParams.set('variant', v.id);
        history.replaceState({}, '', u.toString());
      }
    }

    radios.forEach(function (r) { r.addEventListener('change', aplicar); });

    /* Una pasada al cargar: si se llega por un enlace con ?variant= a una
       talla agotada, el boton y el precio tienen que salir ya correctos. */
    aplicar();
  }

  /* ------------------------------------------------------------------
     Relieve 2.5D del hero.

     Un quad a pantalla completa con dos texturas: la foto y un mapa de altura
     (blanco = cerca). El shader desplaza las UV en funcion de la altura, asi
     la nariz se mueve mas que la oreja y la escultura parece girar. Dos
     iteraciones bastan; con una se nota el estirado en el borde.

     No es 3D de verdad: no hay malla ni visor que cargar. Son dos imagenes y
     treinta lineas de shader, asi que funciona en movil sin penalizar.

     Si no hay WebGL, o el visitante pidio menos movimiento, no se activa y se
     queda el <img> de siempre.
     ------------------------------------------------------------------ */
  function initHero3D() {
    if (reduce) return;
    var lienzo = document.querySelector('[data-pshh-hero-3d]');
    var foto = document.querySelector('img[data-pshh-hero-img]');
    if (!lienzo || !foto) return;

    var gl = lienzo.getContext('webgl', { alpha: false, antialias: false, depth: false })
          || lienzo.getContext('experimental-webgl');
    if (!gl) return;

    var VS = 'attribute vec2 a;varying vec2 v;void main(){v=a*0.5+0.5;gl_Position=vec4(a,0.0,1.0);}';
    var FS = [
      'precision mediump float;',
      'uniform sampler2D uFoto,uAlto;',
      'uniform vec2 uOff,uEsc,uFoco;',
      'varying vec2 v;',
      'void main(){',
      '  vec2 uv=(v-0.5)*uEsc+uFoco;',
      '  float h=texture2D(uAlto,uv).r;',
      '  vec2 p=uv+uOff*(h-0.5);',
      '  h=texture2D(uAlto,p).r;',
      '  p=uv+uOff*(h-0.5);',
      '  p=clamp(p,0.001,0.999);',
      '  gl_FragColor=vec4(texture2D(uFoto,p).rgb,1.0);',
      '}'
    ].join('\n');

    function compilar(tipo, src) {
      var sh = gl.createShader(tipo);
      gl.shaderSource(sh, src); gl.compileShader(sh);
      return gl.getShaderParameter(sh, gl.COMPILE_STATUS) ? sh : null;
    }
    var vs = compilar(gl.VERTEX_SHADER, VS), fs = compilar(gl.FRAGMENT_SHADER, FS);
    if (!vs || !fs) return;
    var prog = gl.createProgram();
    gl.attachShader(prog, vs); gl.attachShader(prog, fs); gl.linkProgram(prog);
    if (!gl.getProgramParameter(prog, gl.LINK_STATUS)) return;
    gl.useProgram(prog);

    var buf = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, buf);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1,-1, 1,-1, -1,1, 1,1]), gl.STATIC_DRAW);
    var locA = gl.getAttribLocation(prog, 'a');
    gl.enableVertexAttribArray(locA);
    gl.vertexAttribPointer(locA, 2, gl.FLOAT, false, 0, 0);

    var uOff = gl.getUniformLocation(prog, 'uOff');
    var uEsc = gl.getUniformLocation(prog, 'uEsc');
    var uFoco = gl.getUniformLocation(prog, 'uFoco');
    /* mismo encuadre que el <img>: asi al pasar de uno a otro nada salta */
    var foco = (getComputedStyle(foto).objectPosition || '50% 50%').split(' ');
    function pct(v, i) { var n = parseFloat(v); return isNaN(n) ? 0.5 : n / 100; }
    /* object-position mide la Y desde arriba; la textura ya va volteada */
    gl.uniform2f(uFoco, pct(foco[0]), 1 - pct(foco[1] || foco[0]));

    /* WebGL coloca el origen de la textura abajo-izquierda y las imagenes lo
       tienen arriba-izquierda: sin este flip la foto sale boca abajo. */
    gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, true);

    function textura(img, unidad, nombre) {
      var t = gl.createTexture();
      gl.activeTexture(gl.TEXTURE0 + unidad);
      gl.bindTexture(gl.TEXTURE_2D, t);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
      gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGB, gl.RGB, gl.UNSIGNED_BYTE, img);
      gl.uniform1i(gl.getUniformLocation(prog, nombre), unidad);
      return t;
    }

    var imgFoto = new Image(), imgAlto = new Image(), listas = 0;
    imgFoto.crossOrigin = imgAlto.crossOrigin = 'anonymous';
    var ratio = 1;

    function cuandoListas() {
      if (++listas < 2) return;
      textura(imgFoto, 0, 'uFoto');
      textura(imgAlto, 1, 'uAlto');
      ratio = imgFoto.naturalWidth / imgFoto.naturalHeight;
      lienzo.hidden = false;
      foto.style.visibility = 'hidden';   /* sigue ahi para el filtro y por si falla */
      medir();
      requestAnimationFrame(bucle);
    }
    imgFoto.onload = imgAlto.onload = cuandoListas;
    imgFoto.onerror = imgAlto.onerror = function () { listas = -99; };
    /* <picture> ya resuelve la foto segun el ancho, asi que currentSrc trae la
       correcta; del relieve hay que elegir la pareja a mano. */
    var mq = window.matchMedia('(max-width: 767px)');
    function relieveQueToca() {
      return (mq.matches && lienzo.getAttribute('data-pshh-depth-movil'))
        || lienzo.getAttribute('data-pshh-depth');
    }
    imgFoto.src = foto.currentSrc || foto.src;
    imgAlto.src = relieveQueToca();

    /* al cruzar el breakpoint cambian las dos imagenes: hay que recargarlas
       o el relieve dejaria de encajar con la foto */
    var cambiar = function () {
      listas = 0;
      imgFoto.src = foto.currentSrc || foto.src;
      imgAlto.src = relieveQueToca();
      var f = (getComputedStyle(foto).objectPosition || '50% 50%').split(' ');
      gl.uniform2f(uFoco, pct(f[0]), 1 - pct(f[1] || f[0]));
    };
    if (mq.addEventListener) mq.addEventListener('change', cambiar);
    else if (mq.addListener) mq.addListener(cambiar);

    var ancho = 0, alto = 0;
    function medir() {
      var r = lienzo.getBoundingClientRect();
      var dpr = Math.min(window.devicePixelRatio || 1, 2);
      ancho = Math.max(1, Math.round(r.width * dpr));
      alto = Math.max(1, Math.round(r.height * dpr));
      lienzo.width = ancho; lienzo.height = alto;
      gl.viewport(0, 0, ancho, alto);
      /* equivalente a object-fit: cover */
      var rc = r.width / r.height;
      if (rc > ratio) gl.uniform2f(uEsc, 1, ratio / rc);
      else gl.uniform2f(uEsc, rc / ratio, 1);
    }
    window.addEventListener('resize', medir);

    var objX = 0, objY = 0, curX = 0, curY = 0, t0 = performance.now();
    window.addEventListener('pointermove', function (e) {
      if (e.pointerType !== 'mouse') return;
      objX = (e.clientX / window.innerWidth - 0.5) * 2;
      objY = (e.clientY / window.innerHeight - 0.5) * 2;
    }, { passive: true });

    var tactil = window.matchMedia('(hover: none)').matches;

    function bucle(ahora) {
      if (tactil) {
        /* sin raton: una deriva lenta, para que en movil tambien respire */
        var s = (ahora - t0) / 1000;
        objX = Math.sin(s * 0.35) * 0.55;
        objY = Math.cos(s * 0.23) * 0.3;
      }
      curX += (objX - curX) * 0.06;
      curY += (objY - curY) * 0.06;
      gl.uniform2f(uOff, -curX * 0.035, curY * 0.022);
      gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);
      requestAnimationFrame(bucle);
    }
  }

  function initFeed() {
    var row = document.querySelector('[data-pshh-feed]');
    if (!row) return;
    function step(dir) {
      var card = row.querySelector('.pshh-social__item');
      var w = card ? card.getBoundingClientRect().width + 16 : 300;
      row.scrollBy({ left: dir * w, behavior: reduce ? 'auto' : 'smooth' });
    }
    var prev = document.querySelector('[data-pshh-feed-prev]');
    var next = document.querySelector('[data-pshh-feed-next]');
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });
  }

  function boot() {
    initMail();
    initReveal();
    initOverlays();
    initSearch();
    initMarquee();
    initShop();
    initAddToCart();
    initGallery();
    initVariants();
    initDob();
    initFeed();
    initTesti();
    initLoadMore();
    initBag();
    initCursor();
    initScrollLoop();
    initHero3D();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.Popposhh = { lockBody: lockBody, setCartCount: setCartCount };
})();
